import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DialogComponent} from './dialog/dialog.component';
import {UploadService} from './upload.service';
import {FileImportTO} from "../../classes/file-import-to";
// import {ImportDestructuringSpacingRule} from "codelyzer";
import {FormTO} from "../../classes/form-to";

let input = Input;

@Component({
  selector: 'sprout-form-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit {

  @Input('button') buttonInd = true;

  @Input('form') form: FormTO;

  fileImportTO: FileImportTO;
  @Output('fileImportTOEventEmitter') fileImportTOEventEmitter = new EventEmitter<FileImportTO>();

  constructor(public dialog: MatDialog, public uploadService: UploadService) { }

  public openUploadDialog() {

    let dialogRef = this.dialog.open(DialogComponent, { width: '50%', height: '50%' });
    dialogRef.componentInstance.form = this.form;

    dialogRef.afterClosed().subscribe(result => {
      this.fileImportTO = <FileImportTO> result;
      this.fileImportTOEventEmitter.emit(this.fileImportTO);
      // console.log('UploadComponent.openUploadDialog.fileImportTO:');
      // console.dir(this.fileImportTO);
    });
  }

  ngOnInit(): void {}
}